var map = {
	"./POG.geojson": 2962,
	"./doroga_zhizni_elektrokabel_osen1942_nefteprovod.ugolnaya.geojson": 3344,
	"./doroga_zhizni_flotilia_malaya.geojson": 3439,
	"./doroga_zhizni_ledovaya_s_22111941.geojson": 3679,
	"./leningradsky_front.geojson": 3766,
	"./volkhovsky_front.geojson": 3853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5929;